import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 650px;
  gap: 25px;
`;

export const ContentStepperOne = styled.div`
  display: flex;
  gap: 80px;
  text-align: center;
  align-items: center;
  flex-direction: column;
  padding-top: 40px;
  width: 100%;
`;

export const TextWrapper = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TermAndConditions = styled.div`
  position: relative;
  background: ${BaSeTheme.colors.defaultColors.white};
  border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  box-shadow: 0px 32px 30px rgba(20, 46, 82, 0.2);
  border-radius: 4px;
  max-width: 650px;
  width: 100%;
  ${handleQuery(`
    width: 90%;
  `)}
`;

export const TermAndConditionsHeader = styled.div`
  position: absolute;
  border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border-radius: 4px;
  height: 80px;
  width: 100%;
  top: -1px;
  left: -1px;
  z-index: ${BaSeTheme.stackOrder.normal};
`;

export const TextHeader = styled.div`
  padding-left: 31px;
  font-weight: 700;
  color: ${BaSeTheme.colors.institucionais.cinzaSebrae45};
`;

export const TermAndConditionsFooter = styled.div`
  position: absolute;
  width: 100%;
  height: 50px;
  left: 0px;
  bottom: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px -4px 8px rgba(20, 46, 82, 0.2);
  z-index: ${BaSeTheme.stackOrder.normal};
`;

export const CheckboxFooter = styled.div`
  padding-left: 16px;
  label {
    color: ${BaSeTheme.colors.institucionais.cinzaSebrae45};
  }
`;

export const TermAndConditionsContent = styled.div`
  overflow: auto;
  padding: 16px;
  max-height: 390px;
  margin-top: 83px;
  margin-bottom: 53px;
  text-align: start;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  color: ${BaSeTheme.colors.institucionais.cinzaSebrae45};
`;

export const ButtonConfirmWrapper = styled.div`
  padding-bottom: 30px;
`;
